import { toast } from '@tempo-io/sui-sonner';
import { useTranslation } from 'react-i18next';
import { DeleteDialog } from '@/components/common/delete-dialog';
import type { Item } from '@/lib/api/types/items';
import { useItemPanelNavigation } from '@/lib/hooks/item-panel/useItemPanelParams';
import { useDeleteItemMutation } from '@/lib/mutations/common/item/useDeleteItemMutation';
import { useGetItemWorkIntegration } from '@/lib/queries/work-integrations/useGetItemWorkIntegration';

export const DeleteItemDialog = ({
  item,
  onOpenChange,
}: {
  item: Item;
  onOpenChange: (open: boolean) => void;
}) => {
  const { t } = useTranslation();
  const { closeItemPanel } = useItemPanelNavigation();
  const deleteItemMutation = useDeleteItemMutation();
  const { isOrphan, isLoading: isWorkIntegrationLoading } = useGetItemWorkIntegration(item);

  return (
    <DeleteDialog
      open
      onOpenChange={onOpenChange}
      isPending={deleteItemMutation.isPending || isWorkIntegrationLoading}
      title={t(($) => $.adaptivePlanner.itemPanel.delete.title)}
      description={
        <p>
          {t(($) => $.adaptivePlanner.itemPanel.delete.description, {
            itemName: item.name,
          })}
        </p>
      }
      cancelLabel={t(($) => $.adaptivePlanner.itemPanel.delete.cancel)}
      confirmLabel={t(($) => $.adaptivePlanner.itemPanel.delete.confirm)}
      onConfirm={() => {
        deleteItemMutation.mutate(
          { itemId: item.id, isOrphanedIntegrationItem: isOrphan },
          {
            onSuccess: () => {
              toast.success(t(($) => $.adaptivePlanner.itemPanel.delete.success));
              onOpenChange(false);
              closeItemPanel();
            },
            onError: () => {
              toast.error(t(($) => $.adaptivePlanner.itemPanel.delete.error));
            },
          },
        );
      }}
    />
  );
};
